module.exports = __webpack_public_path__ + "static/img/3.16d949d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Iverland/3.jpg
// module id = 2+Pm
// module chunks = 0